import { styled } from 'styled-components'

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledAttribute = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledProgressLevel = styled.div`
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(3, 1fr);
`

export const StyledProgressLevelItem = styled.div<{ $isHighlighted: boolean }>`
  width: 100%;
  height: 6px;
  border-radius: 8px;
  background: ${({ theme, $isHighlighted }) =>
    $isHighlighted
      ? theme.colors['N General/Brand']
      : theme.colors['N Surface/Secondary']};
`
